<template>
  <div>
    <SidebarSearch @submit="submitForm" @clear="clearForm">
      <SearchCollapse :expanded="true" title="Dados Gerais">
        <NxInputDocument @update:value="handleInputUpdate('document', $event)"/>
        <NxInputName @update:value="handleInputUpdate('nome', $event, false)"/>
        <NxInput
          name="numProtocolo"
          type="text"
          label="Número do Protocolo:"
          placeholder="Digite o Número do Protocolo:"
          @update:value="handleInputUpdate('numProtocolo', $event, false)"
        ></NxInput>
      </SearchCollapse>

      <SearchCollapse title="Instituição">
        <NxSelectPA @update:value="handleSelectUpdate('numeroPA', $event)" />
        <NxSelectRegional @update:value="handleSelectUpdate('nomeRegional', $event)" />
        <NxSelectFuncionario :variable="employeeTypes.GERENTE" @update:value="handleSelectUpdate('gerenteId', $event)"/>
      </SearchCollapse>

      <SearchCollapse title="Responsável">
        <NxSelectFuncionario :variable="employeeTypes.RESPONSAVEL" @update:value="handleSelectUpdate('responsavelId', $event)"/>
        <NxSelectResponsavelGrupo @update:value="handleSelectUpdate('gruposResponsaveisId', $event)"/>
      </SearchCollapse>

      <SearchCollapse title="Produto">
        <NxSelectProduto @update:value="handleSelectUpdate('produtosId', $event)" />
        <NxInputNumberRange
        v-if="checkBoardType(boardTypes.COBRANCA)"
        label="Dias em atraso:"
        @update:InitialValue="handleInputUpdate('diasAtrasoInicio', $event)"
        @update:FinalValue="handleInputUpdate('diasAtrasoFinal', $event)"
        />
      </SearchCollapse>

      <SearchCollapse title="Ajuizamento" v-if="checkBoardType(boardTypes.AJUIZAMENTO)">
        <NxInput
        name="numProcesso"
        type="number"
        label="Número do Processo:"
        placeholder="Digite o Número do Processo"
        @update:value="handleInputUpdate('numeroProcesso', $event)"
        ></NxInput>
        <NxInput
        name="cnj"
        type="text"
        label="CNJ:"
        placeholder="Digite o CNJ"
        @update:value="handleInputUpdate('cnj', $event)"
        ></NxInput>
        <NxSelectAjuizamentoAssunto @update:value="handleSelectUpdate('assuntoId', $event)"/>
        <NxSelectAjuizamentoComarca @update:value="handleSelectUpdate('comarcaId', $event)"/>
        <NxSelectAjuizamentoFase @update:value="handleSelectUpdate('faseId', $event)"/>
        <NxSelectAjuizamentoObjetoAcao @update:value="handleSelectUpdate('objetoAcaoId', $event)"/>
        <NxSelectAjuizamentoPrognostico @update:value="handleSelectUpdate('prognosticoId', $event)"/>
        <NxInput
        name="advResp"
        type="text"
        label="Advogado Responsável:"
        placeholder="Digite o Nome"
        @update:value="handleInputUpdate('advogadoResponsavel', $event)"
        ></NxInput>
        <NxInput
        name="advContra"
        type="text"
        label="Advogado Contrário:"
        placeholder="Digite o Nome"
        @update:value="handleInputUpdate('advogadoContrario', $event)"
        ></NxInput>
        <NxInput
        name="dataDistribuicao"
        type="date"
        label="Data Distribuição:"
        :max="getCurrentDate()"
        @update:value="handleInputUpdate('dataDistribuicao', $event, false)"
        ></NxInput>
        <NxInput
        name="dataAndamento"
        type="date"
        label="Último Andamento:"
        :max="getCurrentDate()"
        @update:value="handleInputUpdate('ultimoAndamento', $event, false)"
        ></NxInput>
      </SearchCollapse>

      <!-- <SearchCollapse title="Redes Sociais">
        <NxInput
        name="utmCampaign"
        type="text"
        label="UTM Campaign:"
        placeholder="Digite o UTM Campaign"
      ></NxInput>
      </SearchCollapse> -->
    </SidebarSearch>
  </div>
</template>

<script>
import SidebarSearch from '@/containers/layout/sidebars/SidebarSearch.vue'
import SearchCollapse from '@/containers/layout/sidebars/components/SearchCollapse.vue'
import {NxSelectPA, NxSelectRegional, NxSelectFuncionario, NxSelectResponsavelGrupo, NxSelectProduto, NxSelectAjuizamentoAssunto, NxSelectAjuizamentoComarca, NxSelectAjuizamentoFase, NxSelectAjuizamentoObjetoAcao, NxSelectAjuizamentoPrognostico} from '@/components/nexum/components/custom-selects/index.js'
import {NxInputDocument, NxInputName, NxInputNumberRange} from '@/components/nexum/components/custom-inputs/index.js'
import boardTypes from '@/enums/enumBoardTypes.js'
import employeeTypes from '@/enums/enumEmployeeTypes.js'

export default {
  name: 'SidebarQuadro',
  components: { SidebarSearch, SearchCollapse, NxSelectPA, NxSelectRegional, NxSelectFuncionario, NxSelectAjuizamentoAssunto, NxSelectResponsavelGrupo, NxSelectAjuizamentoComarca, NxSelectAjuizamentoFase, NxSelectAjuizamentoObjetoAcao, NxSelectAjuizamentoPrognostico, NxSelectProduto, NxInputDocument, NxInputName, NxInputNumberRange },
  props: {
    board: {
      type: Object,
      required: true,
      default: function () {
        return {}
      }
    }
  },
  data () {
    return {
      // Form data devem seguir as nomenclaturas esperadas pelo backend
      form: {
        nome: null,
        document: null,
        numeroPA: null,
        nomeRegional: null,
        gerenteId: null,
        responsavelId: null,
        gruposResponsaveisId: null,
        produtosId: null,
        diasAtrasoInicio: null,
        diasAtrasoFinal: null,
        numeroProcesso: null,
        cnj: null,
        assuntoId: null,
        comarcaId: null,
        faseId: null,
        objetoAcaoId: null,
        prognosticoId: null,
        advogadoResponsavel: null,
        advogadoContrario: null,
        dataDistribuicao: null,
        ultimoAndamento: null,
        numProtocolo: null
      },
      boardTypes: boardTypes,
      employeeTypes: employeeTypes
    }
  },
  methods: {
    debugLog () {
      console.log(this.form)
    },
    submitForm () {
      // TODO: encode the name before sendind it
      // this.form.nome = encodeURIComponent(this.form.nome)
      this.$nextTick(() => {
        this.$emit('search', this.form)
      })
    },
    clearForm () {
      this.$root.$emit('clearForm')
      this.$nextTick(() => {
        this.submitForm()
      })
    },
    clearField (field) {
      this.form[field] = null
    },
    encodeSpecialChar (dataPropName, value) {
      this.form[dataPropName] = encodeURIComponent(value)
    },
    checkBoardType (typeDesired) {
      let currentType = this.board.tipoBoard
      return typeDesired === currentType
    },
    getCurrentDate () {
      let date = new Date()
      let day = String(date.getDate()).padStart(2, '0')
      let month = String(date.getMonth() + 1).padStart(2, '0')
      let year = date.getFullYear()

      let currentDate = year + '-' + month + '-' + day

      return currentDate
    },
    handleSelectUpdate (fieldName, selectedValue) {
      // If to clear multiple select
      if (Array.isArray(selectedValue) && !selectedValue.length) {
        this.clearField(fieldName)
        return
      }
      // If to clear single select and update both types
      if (selectedValue) {
        this.form[fieldName] = Array.isArray(selectedValue) ? selectedValue.map(v => v.value) : selectedValue.value
      } else {
        this.clearField(fieldName)
      }
    },
    handleInputUpdate (fieldName, inputedValue, clean = true) {
      if (inputedValue) {
        this.form[fieldName] = clean ? inputedValue.replace(/[^a-zA-Z0-9 ]/g, '') : inputedValue
      } else {
        this.clearField(fieldName)
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/private/crm/board/search/SidebarQuadro.vue